import { Text } from "components/text";

export const BooksTableDetailRowSectionLabel = ({
  label,
  count,
}: {
  label: string;
  count?: number;
}) => (
  <div className="flex items-baseline gap-1.5">
    <Text as="span" variant="subtle" className="uppercase">
      {label}
    </Text>
    {count !== undefined && (
      <Text as="span" variant="subtle">
        &middot; {count}
      </Text>
    )}
  </div>
);
